// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2qAUl","resendInfoText":"OnGoingPaymentBox_resendInfoText__1XAJs"};